import TextField from "./TextField";
import MuiAutoComplete from "@mui/material/Autocomplete";
import { get } from "lodash";

export default function Autocomplete({
  label,
  name,
  defaults,
  options = [],
  formikProps,
  placeholder,
  ...props
}) {
  const currentValue = get(formikProps.values, name, "");

  // Find matching object or return null
  const selectedValue =
    options.find((option) => option?.[defaults.primaryKey] === currentValue) ||
    null;

  return (
    <MuiAutoComplete
      fullWidth
      options={options}
      value={selectedValue}
      getOptionLabel={(option) =>
        typeof option === "string"
          ? option
          : option?.[defaults.displayLabel] || ""
      }
      isOptionEqualToValue={(option, value) =>
        option?.[defaults.primaryKey] === value?.[defaults.primaryKey]
      }
      onChange={(_, value) => {
        formikProps.setFieldValue(
          name,
          value ? value[defaults.primaryKey] : ""
        );
      }}
      renderOption={(props, option) => (
        <li {...props} style={{ fontSize: "12.5px", cursor: "pointer" }}>
          {option[defaults.displayLabel]}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          required
          placeholder={!currentValue ? placeholder : ""}
          label={label}
          name={name}
          error={Boolean(
            get(formikProps.touched, name) && get(formikProps.errors, name)
          )}
          helperText={
            get(formikProps.touched, name) && get(formikProps.errors, name)
          }
          onBlur={formikProps.handleBlur}
        />
      )}
      componentsProps={{
        paper: {
          sx: {
            border: "1px solid #00000038",
            borderTopLeftRadius: "0px",
            borderTopRightRadius: "0px",
            borderTop: "0px",
            borderBottomLeftRadius: "12.5px",
            borderBottomRightRadius: "12.5px",
            boxShadow: "none", // optional: remove shadow
            overflow: "hidden",
          },
        },
      }}
      {...props}
    />
  );
}
